import mfaAndResetActivationCodeEntryTemplate from "../core/mfaAndResetActivationCodeEntryTemplate";

const activationCodeEntryTemplate = `
<main class="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 registration"  aria-labelledby="mfa-header-title">
    <div id="mfa-header-title" class="sr-only">{{ "codeSent" | translate }} {{ "step3MfaStep" | translate }} {{ "codeSentMessageLogin" | translate }}
    </div>
    <header class="contained-form-header">
        <h1>
            {{"codeSent"   | translate}}
            <span class="registration-progress">{{ "step3MfaStep" | translate }}</span>
        </h1>
        <p>
            {{"codeSentMessageLogin"   | translate}}
        </p>
    </header>


    <div class="inner-container with-padding with-shadow">
        <form id="verficationForm" name="verficationForm" data-ng-submit="verifyCode('mfa')" autocomplete="off" novalidate>
        
            ${mfaAndResetActivationCodeEntryTemplate}
        
            <div class="form-group checkbox" data-ng-if="authentication.flowName==='mfa'">
                <label for="remember_deviceInput">
                    <input 
                        type="checkbox" 
                        id="remember_deviceInput"
                        name="remember_this_device"
                        ng-model="verification.rememberDevice"
                        ng-click="rememberDeviceClick()"
                    />
                    {{"remeberDevice"  | translate }}
                </label>
            </div>

            <a ui-sref="activationCodeDeliveryOptions" class="no-code" ng-click="noCodeClick()">{{"didNotRecieveCode"  | translate }}</a>

            <div class="form-group clearfix" role="alert">
                
                <button type="submit" class="btn btn-primary btn-lg btn-block margin-top-default outline-btn" ng-disabled="showSpinner==true" id="signin">
                    <span data-ng-hide="showSpinner==true">
                        Sign in
                    </span>
                                                
                    <span data-ng-show="showSpinner==true">
                        <i class="fa fa-circle-o-notch fa-spin"></i>
                        Processing ...
                    </span>
                </button>
            </div>
        </form>
    </div><!--/inner-container with-padding with-shadow/-->
</main>
`;
export default activationCodeEntryTemplate;
